/**
 * 从设备列表构建组织/小组/用户级联数据（纯函数，不 setState）
 * @returns {{ orgStructure: object, organizations: string[], groups: Array<{name:string,org:string}>, users: Array<{name:string,org:string}> }}
 */
export function processMemberData(devices) {
  console.log('处理队员数据，提取组织、小组、用户信息...');

  const orgStructure = {};

  devices.forEach((device) => {
    const orgName = device.org_name || '未分组';
    const groupName = device.group_name || '未分组';
    const userName = device.name || '未知';

    if (!orgStructure[orgName]) {
      orgStructure[orgName] = {
        groups: {},
        members: []
      };
    }

    if (!orgStructure[orgName].groups[groupName]) {
      orgStructure[orgName].groups[groupName] = [];
    }

    if (!orgStructure[orgName].groups[groupName].includes(userName)) {
      orgStructure[orgName].groups[groupName].push(userName);
    }

    if (!orgStructure[orgName].members.includes(userName)) {
      orgStructure[orgName].members.push(userName);
    }
  });

  console.log('级联数据结构:', orgStructure);

  const organizations = Object.keys(orgStructure).sort();
  const groups = Object.keys(orgStructure)
    .flatMap((org) =>
      Object.keys(orgStructure[org].groups).map((group) => ({
        name: group,
        org
      }))
    )
    .sort((a, b) => a.name.localeCompare(b.name));

  const users = Object.keys(orgStructure)
    .flatMap((org) =>
      orgStructure[org].members.map((user) => ({
        name: user,
        org
      }))
    )
    .sort((a, b) => a.name.localeCompare(b.name));

  console.log('提取的组织:', organizations);
  console.log('提取的小组:', groups);
  console.log('提取的用户:', users);

  return { orgStructure, organizations, groups, users };
}

export function filterGroupsByOrg(groups, selectedOrgs) {
  if (selectedOrgs.length === 0) return [];
  return groups.filter((group) => selectedOrgs.includes(group.org));
}

export function filterUsersByOrg(users, selectedOrgs) {
  if (selectedOrgs.length === 0) return [];
  return users.filter((user) => selectedOrgs.includes(user.org));
}

export function filterUsersByGroup(users, selectedGroups, orgStructure = {}) {
  if (selectedGroups.length === 0) return users;

  const selectedUserNames = new Set();
  selectedGroups.forEach((groupName) => {
    Object.values(orgStructure).forEach((org) => {
      if (org.groups[groupName]) {
        org.groups[groupName].forEach((userName) => {
          selectedUserNames.add(userName);
        });
      }
    });
  });

  return users.filter((user) => selectedUserNames.has(user.name));
}
